<div class="d-flex flex-column min-vh-100">
  <app-navbar (headerVisibilityChange)="setHeaderVisible($event)"></app-navbar>
  <div class="navbar-initial-offset" aria-hidden="true"></div>
  @if (isRouteLoading() || authStatus() === 'loading') {
    <app-loading-overlay></app-loading-overlay>
  }
  <main
    class="container-fluid flex-grow-1 px-0"
    [class.main-header-visible]="headerVisible()">
    <router-outlet />
  </main>
  <app-bottom-nav></app-bottom-nav>
</div>
